import axios from 'axios';
import { TokenManager } from './api';

import { API_CONFIG } from '../config/apiConfig';

const apiService = axios.create({
  baseURL: `${API_CONFIG.BASE_URL}/`,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiService.interceptors.request.use(
  (config) => {
    const token = TokenManager.getAccessToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const uploadAvatar = async (file: File) => {
    const formData = new FormData();
    formData.append('avatar', file);

    const token = TokenManager.getAccessToken();

    const response = await axios.post(`${API_CONFIG.BASE_URL}/avatar/upload-avatar`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${token}`
        }
    });
    return response.data;
};


export default apiService;
